import { Injectable, DOCUMENT, inject } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private readonly storageService = inject(StorageService);
  private readonly document = inject<Document>(DOCUMENT);

  private readonly body: HTMLBodyElement;

  constructor() {
    this.body = this.document.body as HTMLBodyElement;
  }

  public initialize(): void {
    this.syncCssClass();
  }

  public get darkTheme(): boolean {
    return this.storageService.data.darkTheme;
  }

  public setLight(): void {
    this.storageService.data.darkTheme = false;
    this.syncCssClass();
  }

  public setDark(): void {
    this.storageService.data.darkTheme = true;
    this.syncCssClass();
  }

  private syncCssClass(): void {
    const cssClass = 'theme-dark';
    if (this.darkTheme) {
      this.body.classList.add(cssClass);
    } else {
      this.body.classList.remove(cssClass);
    }
  }

}
